import { useMutation } from '@tanstack/react-query';

/**
 * Custom hook to validate a Google OAuth token using React Query's mutation.
 *
 * @returns An object containing the mutation state and the `mutate` function to trigger the validation.
 */
export const useGoogleValidateToken = () => {
    return useMutation<
        { audience: string; expires_in: number; scope: string; user_id: string }, // Return type
        Error, // Error type
        { accessToken: string } // Variables type
    >({
        mutationFn: async ({ accessToken }) => {
            if (!accessToken) {
                throw new Error('Access token is required to validate');
            }

            const response = await fetch(`https://www.googleapis.com/oauth2/v1/tokeninfo?access_token=${accessToken}`);

            return response.json();
        },
    });
};
